import { getToken, useCustomerIdRef } from "../api";
import { Api } from "../flightpath-service-api-models";

const johnDeereHttpClient = new Api<{
	johnDeereToken?: string;
}>({
	baseApiParams: { secure: true },
	securityWorker: async data => {

        const headers: Record<string, string> = {};
		if (data?.johnDeereToken) {
			headers.Authorization = `Bearer ${await getToken()}`;
			headers["X-FP-JohnDeere-Authorization"] = `Bearer ${data.johnDeereToken}`;
		}

		const customerId = useCustomerIdRef().value;

		if (customerId) {
			headers["X-Organization-Id"] = customerId;
		}

		return { headers };
	},
});

export const initJohnDeereClient = (defaultUrl: string, jdJwt: string) => {
	johnDeereHttpClient.baseUrl = `${defaultUrl}/cloud-api`;
	johnDeereHttpClient.setSecurityData({
		johnDeereToken: jdJwt,
	});
};

export const refreshJohnDeereToken = async (newJdJwt: string) => {
	johnDeereHttpClient.setSecurityData({
		johnDeereToken: newJdJwt,
	});
};

export const useJohnDeereHttp = (): Api<unknown> =>
	johnDeereHttpClient as Api<unknown>;
